















































import Vue from 'vue'
import { State } from 'vuex-class'
import Component from 'vue-class-component'
import ToolbarComponent from '@/components/Toolbar.vue'
import SidenavComponent from '@/components/Sidenav.vue'
import LoadingScreenComponent from '@/components/LoadingScreen.vue'
import LoadingScreen from '@/modules/core/LoadingScreen'
import { NotificationState, LoadingScreenState, SidenavState,  ToolbarState, MenuItem } from '@/store/types'
import NotificationCenter from '@/components/NotificationCenter.vue'
import { Watch } from 'vue-property-decorator';
import {Location, Route} from 'vue-router';
import JWTToken from '@/modules/auth/types'
import { VuetifyThemeItem } from 'vuetify/types/services/theme'
import ThemeSelector from '@/components/ThemeSelector.vue'
import DevPanel from '@/components/dev/DevPanel.vue';

@Component({
    components: {
        DevPanel,
        'prologue-toolbar': ToolbarComponent,
        'prologue-sidenav': SidenavComponent,
        'loading-screen': LoadingScreenComponent,
        NotificationCenter,
        ThemeSelector,
    },
})
export default class AppComponent extends Vue {
    @State
    public notification: NotificationState

    @State
    public loadingScreen: LoadingScreenState

    @State
    public sidenav: SidenavState

    @State
    public toolbar: ToolbarState

    @State(state => state.auth.token)
    public token: JWTToken | null

    @State(state => state.currentTheme)
    public theme: Partial<VuetifyThemeItem>

    @State(state => state.darkMode)
    public darkMode: boolean

    @Watch('darkMode')
    public darkModeChange (val: boolean) {
        this.$vuetify.theme.dark = val
        localStorage.setItem('config.darkMode', JSON.stringify(val))
    }


    // @Watch('theme')
    // public onThemeChange (theme: PrologueTheme) {
    //     this.$vuetify.theme = theme.vuetifyTheme as VuetifyThemeItem
    // }

    public get fluidContainer () {
        return this.$route.meta.fluidContainer || false
    }

    public devPanel = false

    /**
     * Carga la pantalla de carga inicial
     */
    public async created () {
        LoadingScreen.show('Cargando Prologue', {
            brand: true,
            fullscreen: true,
            determinate: false,
        })

        await this.loadApp()
    }


    /**
     * Oculta la notificación actual mostrada al usuario
     */
    public hideNotification () {
        this.$store.commit('hideNotification')
    }

    /**
     * Carga la información necesaria para al aplicación
     */
    public async loadApp () {
        const darkMode = JSON.parse(localStorage.getItem('config.darkMode') || 'null')
        if (typeof darkMode === 'boolean') {
            this.$store.commit('toggleDarkMode', darkMode)
        }

        await this.$store.dispatch('auth/loadToken')
        await this.$store.dispatch('auth/loadActiveUsers')
        // La aplicación acaba de ser creada pero no existe ningún token de
        // autorización, se redirige el login sin realizar ninguna otra
        // operación
        if (!this.token) {
            this.$store.commit('toggleStopNavigation', false)
            await this.$router.push({name: 'login'})

            LoadingScreen.hide()

            return
        }

        // Carga la configuración del panel establecida en el servidor
        await this.$store.dispatch('loadConfig')

        // Carga los módulos habilitados desde el servidor
        await this.$store.dispatch('loadModules', {force: true})
        // Desbloquea la navegación y carga la ruta cancelada
        this.$store.commit('toggleStopNavigation', false)
        const canceledRoute = this.canceledRoute

        if (!canceledRoute) {
            await this.$router.push({name: 'dashboard'})
        } else {
            await this.$router.push(canceledRoute as Location)
        }

        LoadingScreen.hide()
    }

    public get canceledRoute (): Route | null {
        return JSON.parse(sessionStorage.getItem('canceledRoute') || 'null')
    }
}
